import React from 'react';

export const columnsVehicles = [
  {
    'Header': () => <span className="header-title">FECHA DML</span>,
    'accessor': 'dmlDate',
  },
  {
    'Header': () => <span className="header-title">USUARIO</span>,
    'accessor': 'auditUser',
  },
  {
    'Header': () => <span className="header-title">TRANSACCIÓN</span>,
    'accessor': 'dmlType',
  },
  {
    'Header': () => <span className="header-title">PEDIDO</span>,
    'accessor': 'order',
  },
  {
    'Header': () => <span className="header-title">LÍNEA</span>,
    'accessor': 'line',
  },
  {
    'Header': () => <span className="header-title">CHASIS</span>,
    'accessor': 'chassis',
  },
  {
    'Header': () => <span className="header-title">ESTADO FLOTANTE</span>,
    'accessor': 'floatingState',
  },
  {
    'Header': () => <span className="header-title">FECHA RESERVA FLOTANTE</span>,
    'accessor': 'reservationFloatingDate',
  },
  {
    'Header': () => <span className="header-title">ASESOR</span>,
    'accessor': 'adviserName',
  },
  {
    'Header': () => <span className="header-title">CLIENTE</span>,
    'accessor': 'finalClient',
  },
  {
    'Header': () => <span className="header-title">NOMBRE CLIENTE FINAL</span>,
    'accessor': 'finalCustomerName',
  },
  {
    'Header': () => <span className="header-title">FECHA SOL NAC</span>,
    'accessor': 'solNacDate',
  },
  {
    'Header': () => <span className="header-title">NÚMERO SOL NAC</span>,
    'accessor': 'solNacNumber',
  },
  {
    'Header': () => <span className="header-title">DEALER</span>,
    'accessor': 'dealerName',
  },
  {
    'Header': () => <span className="header-title">SFX</span>,
    'accessor': 'suffix',
  },
  {
    'Header': () => <span className="header-title">KATASHIKI</span>,
    'accessor': 'masterCode',
  },
  {
    'Header': () => <span className="header-title">COLOR EXTERNO</span>,
    'accessor': 'color',
  },
  {
    'Header': () => <span className="header-title">COLOR INTERNO</span>,
    'accessor': 'internalColor',
  },
  {
    'Header': () => <span className="header-title">RAMV</span>,
    'accessor': 'ranmv',
  },
  {
    'Header': () => <span className="header-title">AÑO MODELO</span>,
    'accessor': 'yearModel',
  },
  {
    'Header': () => <span className="header-title">UBICACIÓN</span>,
    'accessor': 'location',
  },
  {
    'Header': () => <span className="header-title">MOTOR</span>,
    'accessor': 'motor',
  },
  {
    'Header': () => <span className="header-title">FECHA LLEGADA</span>,
    'accessor': 'arrivalDate',
  },
  {
    'Header': () => <span className="header-title">DESTINO</span>,
    'accessor': 'destiny',
  },
  {
    'Header': () => <span className="header-title">NÚMERO FACTURA</span>,
    'accessor': 'invoiceNumber',
  },
  {
    'Header': () => <span className="header-title">BUQUE</span>,
    'accessor': 'vessel',
  },
  {
    'Header': () => <span className="header-title">IMPORTADOR</span>,
    'accessor': 'importer',
  },
  {
    'Header': () => <span className="header-title">OBSERVACIONES</span>,
    'accessor': 'observationFloatingInventory',
  },
];
